var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutomatedCandidateNurturing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 111.517,
    height: 105.91,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(-506 -1689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(507 1693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M60.362,33.045h.027a.9.9,0,0,1,.747.4l2.77,4.132,2.77-4.132a.9.9,0,0,1,.747-.4h.027a8.021,8.021,0,0,1,7.381,5.742l.049.177a13.579,13.579,0,1,0-21.948,0l.054-.194A8.017,8.017,0,0,1,60.362,33.045Zm3.544-14.608c3.636,0,5.807,2.25,5.807,6.019,0,4.248-2.537,9.187-5.807,9.187S58.1,28.7,58.1,24.456c0-3.768,2.172-6.019,5.807-6.019",
    transform: "translate(-8.147 -2.817)",
    fill: "#8962ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M74.243,43.982l-.376-1.361a6.263,6.263,0,0,0-5.2-4.383l-3.235,4.826a.9.9,0,0,1-1.494,0L60.7,38.238A6.258,6.258,0,0,0,55.5,42.6l-.381,1.38a13.553,13.553,0,0,0,19.124,0",
    transform: "translate(-8.923 -6.19)",
    fill: "#0d011c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M65.754,32.392c1.91,0,4.008-3.867,4.008-7.388,0-2.8-1.349-4.22-4.008-4.22S61.746,22.2,61.746,25c0,3.521,2.1,7.388,4.008,7.388",
    transform: "translate(-9.995 -3.364)",
    fill: "#0d011c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M58.743,7.143a.9.9,0,0,1,.319.687V9.5l8.228-4.75L59.063,0V2.2a.9.9,0,0,1-.78.891,25.3,25.3,0,0,0-11.2,45.758,1.884,1.884,0,1,0,2.171-3.079A21.536,21.536,0,0,1,58.013,6.943.9.9,0,0,1,58.743,7.143Z",
    transform: "translate(-5.884 0)",
    fill: "#0d011c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M90.731,29.539A25.346,25.346,0,0,0,80,8.851a1.884,1.884,0,0,0-2.171,3.08,21.536,21.536,0,0,1-8.758,38.827.9.9,0,0,1-1.05-.887V48.2l-8.229,4.75,8.229,4.75V55.5a.9.9,0,0,1,.78-.892A25.363,25.363,0,0,0,90.731,29.539",
    transform: "translate(-9.678 -1.377)",
    fill: "#0d011c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M121.494,38.241a2.824,2.824,0,0,0-.395-.028,3.558,3.558,0,0,0-3.28,3.224l-.236,1.588v.01l-2.3,15.53a.9.9,0,0,1-.115.325l-6.783,11.486c-.013.021-.027.04-.041.06a5.8,5.8,0,0,1-3.016,2.475L94.6,78.335a.9.9,0,0,1-.811-1.606l10.784-5.448q.052-.025.106-.045a3.993,3.993,0,0,0,2.156-1.763l.005-.008a2.932,2.932,0,0,0,.269-2.448,3.147,3.147,0,0,0-2.755-1.975h-.015a4.134,4.134,0,0,0-1.775.221c-.138.049-13.46,4.705-16.933,7.568a32.305,32.305,0,0,0-7.116,10.1c-.7,1.888-.647,8.935-.433,15.063l19.229,2.84.639-2.739a.9.9,0,0,1,.2-.385L113.518,80l7.236-15.088,3.333-22.547A3.47,3.47,0,0,0,121.494,38.241Z",
    transform: "translate(-12.617 -6.186)",
    fill: "#0d011c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M113.767,64.433l.043-16.44a3.474,3.474,0,0,0-3.162,3.689l-.035,13.291A5.068,5.068,0,0,1,113,66.293Z",
    transform: "translate(-17.906 -7.769)",
    fill: "#0d011c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M121.881,43.89a2.946,2.946,0,0,0-2.252-1.127,3.473,3.473,0,0,0-3.173,3.618c0,.014,0,.027-.005.041s0,.02,0,.032l-.045,17.313a.884.884,0,0,1-.067.339l-.523,1.275,3.848-6.516Z",
    transform: "translate(-18.749 -6.922)",
    fill: "#0d011c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M74.308,111.24a1.568,1.568,0,0,0-1.543,1.331l-.862,5.834a1.564,1.564,0,0,0,1.314,1.77L98.448,123.9a1.48,1.48,0,0,0,.227.017,1.569,1.569,0,0,0,1.543-1.332l.862-5.832a1.565,1.565,0,0,0-1.314-1.77l-25.231-3.726A1.463,1.463,0,0,0,74.308,111.24Zm17.2,7.08A3.908,3.908,0,0,1,95.355,115a3.959,3.959,0,0,1,.572.042,3.888,3.888,0,0,1,3.278,4.414,3.908,3.908,0,0,1-3.842,3.32,3.965,3.965,0,0,1-.572-.042,3.888,3.888,0,0,1-3.278-4.414Z",
    transform: "translate(-11.637 -18.007)",
    fill: "#8962ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M99.184,122.028a2.121,2.121,0,0,0,.308.023,2.1,2.1,0,0,0,2.063-1.784,2.09,2.09,0,0,0-1.761-2.372,2.141,2.141,0,0,0-.309-.023,2.1,2.1,0,0,0-2.063,1.784,2.09,2.09,0,0,0,1.762,2.372Z",
    transform: "translate(-15.767 -19.081)",
    fill: "#0d011c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M16.067,65.381l-.523-1.275a.917.917,0,0,1-.067-.339l-.045-17.313c0-.012,0-.021,0-.032s-.005-.027-.006-.041a3.472,3.472,0,0,0-3.166-3.618A2.95,2.95,0,0,0,10,43.89l2.215,14.974Z",
    transform: "translate(-1.619 -6.922)",
    fill: "#0d011c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M19.433,66.293a5.083,5.083,0,0,1,2.392-1.319l-.034-13.29a3.473,3.473,0,0,0-3.163-3.69l.043,16.44Z",
    transform: "translate(-3.015 -7.769)",
    fill: "#0d011c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M26.187,98.1l.639,2.739L46.056,98c.213-6.127.264-13.174-.433-15.063a32.294,32.294,0,0,0-7.117-10.1c-3.473-2.864-16.793-7.52-16.928-7.567a4.148,4.148,0,0,0-1.778-.223h-.016a3.144,3.144,0,0,0-2.754,1.975,2.934,2.934,0,0,0,.268,2.448l.006.008a4,4,0,0,0,2.156,1.763.775.775,0,0,1,.1.045L30.347,76.73a.9.9,0,0,1-.81,1.6L18.8,72.912a5.788,5.788,0,0,1-3.016-2.475c-.013-.019-.028-.039-.041-.06L8.962,58.891a.889.889,0,0,1-.116-.326L6.55,43.036v-.01l-.236-1.589a3.558,3.558,0,0,0-3.279-3.225,2.846,2.846,0,0,0-.4.029A3.471,3.471,0,0,0,.047,42.364L3.38,64.912,10.617,80,25.99,97.712A.892.892,0,0,1,26.187,98.1Z",
    transform: "translate(0 -6.186)",
    fill: "#0d011c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M54.649,112.571a1.568,1.568,0,0,0-1.543-1.331,1.591,1.591,0,0,0-.226.017l-25.231,3.726a1.565,1.565,0,0,0-1.314,1.769l.862,5.834a1.569,1.569,0,0,0,1.543,1.331,1.593,1.593,0,0,0,.227-.017L54.2,120.175a1.565,1.565,0,0,0,1.314-1.769Zm-19.473,8.635a3.862,3.862,0,0,1-2.554,1.528,3.954,3.954,0,0,1-.571.042,3.908,3.908,0,0,1-3.842-3.32,3.888,3.888,0,0,1,3.278-4.414,3.958,3.958,0,0,1,.572-.042,3.908,3.908,0,0,1,3.842,3.32A3.861,3.861,0,0,1,35.176,121.206Z",
    transform: "translate(-4.26 -18.007)",
    fill: "#8962ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M32.764,117.873a2.141,2.141,0,0,0-.309.023,2.09,2.09,0,0,0-1.761,2.372,2.1,2.1,0,0,0,2.062,1.784,2.133,2.133,0,0,0,.309-.023,2.09,2.09,0,0,0,1.762-2.372A2.1,2.1,0,0,0,32.764,117.873Z",
    transform: "translate(-4.965 -19.081)",
    fill: "#0d011c"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 114,
    height: 114,
    transform: "translate(506 1689)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedCandidateNurturing);
export default __webpack_public_path__ + "static/media/automated-candidate-nurturing.a1abe7bdee0e77e39fbae73ed5feca3a.svg";
export { ForwardRef as ReactComponent };